module.exports = __webpack_public_path__ + "assets/export.45e2099b.svg";